import * as _ from "lodash-es";
import React, { useContext } from "react";
import FileUploadResourceTypeEnum from "../../../models/FileUploadResourceTypeEnum";
import IAttachment from "../../../models/IAttachment";
import ICatalog_Item from "../../../models/ICatalog_Item";
import OwButton from "../OwButton/OwButton";
import OwS3ImageViewer from "../OwS3ImageViewer/OwS3ImageViewer";
import OwS3Uploader from "../OwS3Uploader/OwS3Uploader";
import "./OwCatalogImagePhotoSet.scss";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import {SocketContext} from "../../../contexts/SocketContext";
import UiContext from "../../../contexts/UiContext";

type Props = {
    imageSeq?: number;
    totalSeq?: number;
    catalogItem?: ICatalog_Item;
    deleteImageFn: (attachmentGuid: string) => void;
    isProcessed: (isProcessed: boolean) => void;
};

export const OwCatalogImagePhotoSet = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const deletePhoto = () => {
        if (props.catalogItem) {
            const imageSeqAttachments = _.reject(props.catalogItem.Attachments, ["image_seq", null]);
            const attachments = _.sortBy(imageSeqAttachments, "image_seq");

            if (props.imageSeq) {
                const attachment = attachments[props.imageSeq - 1];

                if (attachment) {
                    props.deleteImageFn(attachment.guid);
                }
            }
        }
    };

    let imageIndex = 0;

    if (props.imageSeq) {
        imageIndex = props.imageSeq - 1;
    }

    let hasImage = false;

    let imageSeqAttachments: IAttachment[] = [];
    let attachments: IAttachment[] = [];

    if (props.catalogItem) {
        imageSeqAttachments = _.reject(props.catalogItem.Attachments, ["image_seq", null]);
        attachments = _.sortBy(imageSeqAttachments, "image_seq");
    }

    if (props.imageSeq) {
        const attachment = attachments[props.imageSeq - 1];

        if (attachment) {
            hasImage = true;
        }
    }

    return (
        <div className="OwCatalogImagePhotoSet">
            <div className={"imageViewer mb-2 d-flex flex-column"}>
                <OwS3ImageViewer
                    catalogItem={props.catalogItem}
                    isMicroView={false}
                    attachmentIndex={imageIndex}
                    imageSeq={props.imageSeq}
                    totalSeq={props.totalSeq}
                    hideEmptyImage={false}
                    microViewSize={"15rem"}
                    className={"w-7r h-7r"}
                />
                <div>
                    <OwButton
                        disabled={!hasImage}
                        className={"btn-link " + (hasImage ? "text-danger" : "text-muted")}
                        centerIconClass={"fad fa-trash-alt"}
                        fn={deletePhoto}
                        iconTitle={"delete"}
                    />
                </div>
            </div>
            <div>
                <OwS3Uploader
                    socket={socket}
                    isReadOnly={false}
                    resourceType={FileUploadResourceTypeEnum.catalogItem}
                    supplierModel={supplierModel}
                    userModel={userModel}
                    dropOnly={true}
                    imagesOnly={true}
                    imageSeq={props.imageSeq}
                    catalogItemGuid={props.catalogItem?.guid}
                    notifyFn={uiContext.notifyFn}
                    isProcessedFn={props.isProcessed}
                />
            </div>
        </div>
    );
}
